<template>
  <section>
    <b-loading :active="!iiifUrl && !xmlJson"></b-loading>
    <div v-if="iiifUrl && xmlJson">
    <TranscriptionInterfaceLocal
      :iiifUrl="iiifUrl"
      :xmlJson="xmlJson"
    />
  </div>
  </section>
</template>

<script>
import TranscriptionInterfaceLocal from "../components/DetailView/TranscriptionInterfaceLocal.vue";

import { mapState, mapGetters } from "vuex";

import imageMixin from "../mixins/image.js";

const json = require("../assets/page1.json");

export default {
  components: {
    TranscriptionInterfaceLocal,
  },
  mixins: [imageMixin],
  computed: {
    ...mapState("content", ["iiifUrl", "xmlJson"]),
  },
  props: {
    // iiifUrl: {
    //   type: String,
    //   required: true,
    // },
    // xmlJson: {
    //   type: Object,
    //   required: true,
    // },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
